import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GALLERY_LIST, GALLERY_ADDEDIT, GALLERY_GETONE, UPLOAD_PHOTOS, GALLERY_DELETE } from "../../api/constApi";
import { GalleryListApi, AddEditGalleryApi, GetOneGalleryApi, UploadPhotosApi, DeleteGalleryApi } from "../Services/galleryService";

export const uploadedImage = createAsyncThunk(UPLOAD_PHOTOS, async (payload) => {
    const response = await UploadPhotosApi(payload);
    return response.data;
});

export const galleryList = createAsyncThunk(GALLERY_LIST, async (payload) => {
    const response = await GalleryListApi(payload);
    return response.data;
});

export const addEditGallery = createAsyncThunk(GALLERY_ADDEDIT, async (payload) => {
    const response = await AddEditGalleryApi(payload);
    return response.data;
});

export const getOneGallery = createAsyncThunk(GALLERY_GETONE, async (payload) => {
    const response = await GetOneGalleryApi(payload);
    return response.data;
});

export const deleteGallery = createAsyncThunk(GALLERY_DELETE, async (payload) => {
    const response = await DeleteGalleryApi(payload);
    return response.data;
});


export const gallerySlice = createSlice({
    name: "gallery",
    initialState: {
        gallery: null,
        token: null,
        error: null,
        uploadedImages: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(galleryList.fulfilled, (state, action) => {
            state.gallery = action?.payload;
        });
        builder.addCase(addEditGallery.fulfilled, (state, action) => {
            state.gallery = action?.payload?.Data;
          });
        // builder.addCase(uploadedImage.fulfilled, (state, action) => {
        //     const imageUrls = Array.isArray(action.payload.imageUrls) 
        //         ? action.payload.imageUrls 
        //         : [action.payload.imageUrl];
        //     state.uploadedImages = [...state.uploadedImages, ...imageUrls];
        // });
    }
});

export default gallerySlice.reducer;